import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from "classnames";
import CupoySrefView from "components/commons/router/CupoySrefView";
import _ from "lodash";

const ArrowDownIcon = require('react-icons/lib/md/keyboard-arrow-down');

class PagedList extends PureComponent {

    static propTypes = {
        page: PropTypes.number.isRequired,
        pageLen: PropTypes.number.isRequired,
        getListItemFrom: PropTypes.func.isRequired,
        totalCount: PropTypes.number.isRequired,
        maxPages: PropTypes.number,
        pageStateName: PropTypes.string,
        goToPages: PropTypes.func,
        getItemsInRanage: PropTypes.func.isRequired,
        renderItemRow: PropTypes.func.isRequired,
        renderItemHeaderRow: PropTypes.func,
        renderFilterContent: PropTypes.func,
        querys: PropTypes.object,
        colspan: PropTypes.number.isRequired,
    };

    static defaultProps = {
        maxPages: 7,
    };

    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            isError: false,
            isEmpty: false,
            isExpandFilter: false,
        };

        this.start = 0;
        this.toggleExpandFilter = this.toggleExpandFilter.bind(this);
    }

    componentDidMount() {

        this.init(this.props);
    }

    componentWillReceiveProps(nextProps) {
        
        if (nextProps.page === this.props.page && nextProps.pageLen === this.props.pageLen && _.isEqual(nextProps.querys, this.props.querys)) {
            return;
        }

        this.init(nextProps);
    }

    init(props) {

        if(this.state.isLoading) {
            return;
        }

        const {
            page,
            pageLen,
            querys,
        } = props;

        this.setState({
            isLoading: true,
            isEmpty: false,
            isError: false,
        }, () => {

            this.start = (page - 1) * pageLen;

            if(this.start < 0) {
                this.start = 0;
            }

            this.props.getListItemFrom && this.props.getListItemFrom(this.start, querys).then((result) => {
                this.setState({
                    isLoading: false
                });
            }, (error) => {
                if(error && error.code === 'error.rscNotExist') {
                    this.setState({
                        isEmpty: true,
                        isLoading: false
                    });
                } else {
                    this.setState({
                        isError: true,
                        isLoading: false
                    });
                }
            });
        });
    }

    toggleExpandFilter(isExpandFilter) {

        this.setState({
            isExpandFilter: isExpandFilter,
        });
    }

    getPageNode(pageIndex, text) {

        const {
            page,
            goToPages,
            pageStateName,
            querys,
        } = this.props;

        if(this.props.goToPages) {
            return (
                <a
                    key={pageIndex}
                    onClick={() => goToPages(pageIndex)}
                    className={classNames('button page-item', {
                       'blue': page === (pageIndex)
                    })}
                >
                    {text}
                </a>
            )
        } else {
            return (
                <CupoySrefView 
                    key={pageIndex}
                    className={classNames('button page-item', {
                       'blue': page === (pageIndex)
                    })}
                    statename={pageStateName}
                    params={{
                        page: pageIndex,
                    }}
                    querys={querys}
                >
                    {text}
                </CupoySrefView>
            );
        }
    }

    renderPageBar() {

        const {
            page,
            pageLen,
            totalCount,
            maxPages,
        } = this.props;

        // 錯誤狀態回傳空的話總數就為0
        const realTotal = this.state.isEmpty ? 0 : totalCount;
        const totalPage = Math.ceil(realTotal / pageLen); // 共幾頁
        const startDistance = page - 1; // 與第一頁距離幾頁
        const endDistance = totalPage - page; // 與最後一頁距離幾頁
        var otherPageMax = (maxPages - 1); // 扣掉自己可以顯示的頁數
        var prevPageMax = Math.ceil(otherPageMax / 2); // 前面最多可顯示頁數
        var nextPageMax = otherPageMax - prevPageMax; // 後面最多可顯示頁數

        if(startDistance < prevPageMax) {
            prevPageMax = startDistance;
            nextPageMax = otherPageMax - prevPageMax;
        } else if(endDistance < nextPageMax) {
            nextPageMax = endDistance;
            prevPageMax = otherPageMax - nextPageMax;
        }

        var startPage = page - prevPageMax;
        var endPage = page + nextPageMax;

        var pageList = [];
        
        for(var i = startPage; i <= endPage; i++) {
            if(i > 0 && i <= totalPage) {
                pageList.push(i);
            }
        }

        var prevPageNode = null;
        var nextPageNode = null;
        var firstPageNode = null;
        var lastPageNode = null;

        if(page > 1) {
            prevPageNode = this.getPageNode(page - 1, '<');
        } else {
            prevPageNode = (<div className="button page-item transparent-item"></div>);
        }

        if(page < totalPage) {
            nextPageNode = this.getPageNode(page + 1, '>');
        } else {
            nextPageNode = (<div className="button page-item transparent-item"></div>);
        }

        if(startPage > 1) {
            firstPageNode = this.getPageNode(1, '...');
            pageList.shift();
        }

        if(endPage < totalPage) {
            lastPageNode = this.getPageNode(totalPage, '...');
            pageList.pop();
        }

        const pageNodes = pageList.map((pageIndex, index) => {
            return this.getPageNode(pageIndex, pageIndex);
        });

        return (
            <div className="table-list-footer">
                <div className="page-list">
                    {prevPageNode}
                    {firstPageNode}
                    {pageNodes}
                    {lastPageNode}
                    {nextPageNode}
                </div>
            </div>
        );
    }

    renderContent() {

        const { 
            page,
            pageLen,
            totalCount,
            getItemsInRanage,
            renderItemRow,
            renderItemHeaderRow,
            colspan,
        } = this.props;

        const start = this.start;
        const items = getItemsInRanage(start, start + pageLen);
        const header = renderItemHeaderRow ? renderItemHeaderRow() : null;
        const pageBar = this.renderPageBar(page, pageLen, items, totalCount);
        var itemNodes = null;
        
        if(page > 0 && !this.state.isEmpty && !this.state.isError) {
            itemNodes = items.map((item, index) => {
                return renderItemRow && renderItemRow(item, index, start);
            });
        }

        return (
            <div
                className={classNames("table-list-wrapper", {
                   'has-header': header
                })}
            >
                <div className="table-scroll-content">
                    <table className="table-list">
                        {header}
                        <tbody>
                            {itemNodes}
                            {this.state.isLoading ?
                                <tr>
                                    <td className="table-list-col text-center"
                                        colSpan={colspan}
                                    >
                                        <i className="zmdi zmdi-spinner animate-spinner"></i> 讀取中
                                    </td>
                                </tr>
                                :
                                null
                            }
                            {this.state.isEmpty ?
                                <tr>
                                    <td className="table-list-col text-center"
                                        colSpan={colspan}
                                    >
                                        沒有任何內容
                                    </td>
                                </tr>
                                :
                                null
                            }
                            {this.state.isError ?
                                <tr>
                                    <td className="table-list-col text-center"
                                        colSpan={colspan}
                                    >
                                        發生錯誤，請再嘗試一次
                                    </td>
                                </tr>
                                :
                                null
                            }
                            {page <= 0 ?
                                <tr>
                                    <td className="table-list-col text-center"
                                        colSpan={colspan}
                                    >
                                        頁碼錯誤，請檢查網址是否正確
                                    </td>
                                </tr>
                                :
                                null
                            }
                        </tbody>
                    </table>
                    {pageBar}
                </div>
            </div>
        );
    }

    render() {

        const {
            isExpandFilter,
        } = this.state;

        const {
            renderFilterContent,
        } = this.props;

        const content = this.renderContent();

        if(renderFilterContent) {
            return (
                <div className="has-search-bar">
                    <div
                        className={classNames("search-bar", {
                           'expand': isExpandFilter
                        })}
                    >
                        <div className="search-content">
                            {renderFilterContent()}
                        </div>
                        <div className="toggle-btn" onClick={() => this.toggleExpandFilter(!isExpandFilter)}>
                            {isExpandFilter ? '收合過濾條件' : '展開過濾條件'}
                            <div className="expand-icon"><ArrowDownIcon/></div>
                        </div>
                    </div>
                    {content}
                </div>
            );
        }

        return content;
    }
}

export default PagedList;


// WEBPACK FOOTER //
// ./src/components/commons/PagedList.jsx